import './loginForm.less';

import {Translate} from "../../hoc/translate";
import axios from "axios/index";
import {getMeta} from "../../js/core/Helpers/Helpers";
import { AxiosLogin } from "../../axiosInstances/axiosInstances";
import Cup from './images/cup.jpg';
import Paths from '../../../dev/js/core/Helpers/Paths';


const loginForm = props => {
    let container = document.getElementsByTagName('body')[0] || document.getElementsByClassName('body')[0];
    let loginBtn = document.querySelector('#js-login-btn');
    let mobileLoginBtn = document.querySelector('#js-mobile-login-btn');
    let required = ['email','password'];
    let msgObject = {
        status : '',
        msg: ''
    };
    
    
    let template = `<div id="loginFormWrapper" class="closable"><i class="fa fa-times modal-closable"></i>
        <div id="loginFormContainer">
            <img loading="lazy" src="${Paths.assets}${Cup}" class="loginForm__cup" alt="" />
            <form id="loginForm" method="POST" action="login-ajax.html">
                <div class="loginForm__title">${props.translate('cart_login_header')}</div>
                
                <div id="loginForm__left"></div>
                <div class="loginForm__input-wrapper">
                    <label class="loginForm__text-input-label" for="email">${props.translate('email')}</label>
                    <input class="loginForm__text-input js-login-input" id="email" type="text" name="email" placeholder="" />
                </div>
                <div class="loginForm__input-wrapper">
                    <label class="loginForm__text-input-label" for="password">${props.translate('password')}</label>
                    <input class="loginForm__text-input js-login-input" id="password" type="password" name="password" placeholder="" />
                </div>
                <div id="msgContainer"></div>
                <input id="csrfSecureToken" type="hidden" name="csrfSecureToken" value="${getMeta('csrf-token')}" />
                <button type="submit" class="loginForm__submit">${props.translate('login')}</button>
                
                <div class="loginForm__subtitle">
                ${props.translate('cart_create_account')} <a href="rejestracja.html">${props.translate('cart_register')}</a><br>
                ${props.translate('forgot_password_')} <a href="przypomnij-haslo.html">${props.translate('reset_password')}</a>
                </div>
            </form>
        </div>
	<div id="loginBackdrop"></div></div>`;
    
    container.insertAdjacentHTML('afterbegin', template);
    let loginForm = document.getElementById('loginForm');
    let loginFormContainer = document.getElementById('loginFormContainer');
    let loginFormWrapper = document.getElementById('loginFormWrapper');
    let loginBackdrop = document.getElementById('loginBackdrop');
    
    let inputs = Array.from(document.getElementsByClassName('js-login-input'));
    
    inputs.map(input => {
        input.addEventListener('focus', () => {
                input.previousElementSibling.classList.add('shorten');
            });
        input.addEventListener('blur', () => {
                input.value === '' ? input.previousElementSibling.classList.remove('shorten') : null;
            })
    });
    
    const setMessageContent = fields => {
        msgObject.status = '';
        msgObject.msg = ``;
        
        let message = ``;
        
        message = fields.reduce ( (message, field, index, array) => {
           message = index === (array.length - 1) ? message + `<strong>${field}</strong>` : message + `<strong>${field}</strong>, `;
           return message;
        }, '');
        
       msgObject.status = 'error';
       msgObject.msg = `<p>Pola: ${message} są wymagane. </p>`;
    };
    
    
    const validate = form => {
        let checkRequired = required.reduce( (result, field) => {
         ( !form[field].value || form[field].value == '')  ? result.push(form[field].name) : null;
         return result;
        }, []);
       
    
       return checkRequired.length === 0 ? true : setMessageContent(checkRequired);
    };
    
    const showMessage = () => {
        let msgContainer = document.getElementById('msgContainer');
        
        msgContainer.innerHTML = '';
        msgContainer.innerHTML = msgObject.msg;
    };
    
    
    const submitForm = (form, action) => {
        return new Promise((resolve, reject) => {
            AxiosLogin.post(action, form)
                .then(response => {
                    msgObject.status = response.data.status;
                    msgObject.msg = response.data.msg;
                    resolve();
                })
                .catch(error => {
                        console.log(error);
                        reject();
                    }
                );
        
        })
    };
    
    const redirectIfLoggedIn = () => {
        if (msgObject.status === 'success'){
            setTimeout(() => {
                window.location.reload();
            }, 500);
        }
    };
    
    const toggleForm = () => {
        loginFormWrapper.classList.toggle('active');
        
        setTimeout(()=>{
            loginFormContainer.classList.toggle('opened');
        }, 200);
    };

    
    loginBackdrop.addEventListener('click', toggleForm);
    
    if(loginBtn) {
        loginBtn.addEventListener('click', toggleForm);
    }
	if(mobileLoginBtn) {
		mobileLoginBtn.addEventListener('click', toggleForm);
	}
    
    loginForm.addEventListener('submit', e => {
        e.preventDefault();
        let formObj = {
            email : {
                name : 'E-mail',
                value:  document.getElementById('email').value
            },
            password : {
                name : 'Hasło',
                value: document.getElementById('password').value
            },
            token : getMeta('csrf-token')
        };
        

        if (validate(formObj) === true){
            let promise = submitForm(formObj, e.target.action);
            promise.then( () => {
                showMessage(msgObject);
                redirectIfLoggedIn();
            } );

        } else {
            showMessage(msgObject);
        }
        
    });
};

export default Translate(loginForm);




// WEBPACK FOOTER //
// ./components/loginForm/loginForm.js